import { useQuery } from "@tanstack/react-query";
import { Link, useNavigate, useParams } from "@tanstack/react-router";
import { api, queryKeys } from "../api";
import { SessionsTable } from "../components/SessionsTable";
import { ErrorState, Skeleton } from "../components/States";
import { PageHead } from "../components/ui";
import { formatDateTime } from "../lib/format";

export function VisitPage() {
  const { id } = useParams({ strict: false }) as { id: string };
  const navigate = useNavigate();
  const visit = useQuery({ queryKey: queryKeys.visit(id), queryFn: () => api.visit(id) });
  if (visit.isPending) return <Skeleton />;
  if (visit.isError) return <ErrorState error={visit.error} retry={() => void visit.refetch()} />;
  const v = visit.data;
  return (
    <>
      <PageHead>
        <div className="page-title">
          <Link to="/" className="btn ghost">
            ← Sessions
          </Link>
          <h1>Visit {v.id.slice(0, 10)}…</h1>
          <span className="count">
            {v.segments.length} segment{v.segments.length === 1 ? "" : "s"} · started {formatDateTime(v.startedAt)} · last seen {formatDateTime(v.lastSeenAt)}
          </span>
        </div>
      </PageHead>
      <div className="card">
        <SessionsTable sessions={v.segments} onOpen={(sid) => void navigate({ to: "/sessions/$id", params: { id: sid } })} />
      </div>
    </>
  );
}
